import React, { useEffect, useContext, useState, forwardRef, useImperativeHandle} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TextField, Checkbox, FormGroup, Typography, FormControlLabel, Snackbar } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import { HttpService } from '../../apiAuthorization/httpService';
import { Context } from '../contexts/siteContext.js';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MuiAlert from '@material-ui/lab/Alert';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import LensIcon from '@material-ui/icons/Lens';
import classNames from 'classnames';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '7px 0px',
            width: '100%'
        }
    },
    button: {
        width: '15%',
        float: 'right'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    listItemIcon: {
        minWidth: '20px'
    },
    lensIcon: {
        width: '10px'
    },
    subItemList: {
        marginLeft:"20px"
    },
    subtext: {
        "& > span": {
            fontSize: "12px"
        }
    }
}));

const ObservationLogAdd = forwardRef((props, ref) => {
    const classes = useStyles();
    const { defaultSite } = useContext(Context);
    const { attendants, observationLogSelected, getObservationLog,close} = props;
    const [observationTemplateOption, setObservationTemplateOption] = useState(props.observationTemplate);
    const [interventionTemplateOption, setInterventionTemplateOption] = useState(props.interventionTemplate);
    const [safetyCheckTemplateOption, setSafetyCheckTemplateOption] = useState(props.safetyCheckTemplate);
    const [locationCodeTemplateOption, setLocationCodeTemplateOption] = useState(props.locationCodeTemplate ? props.locationCodeTemplate : []);
    const [observationLogDto, setObservationLogDto] = useState(observationLogSelected);
    const [attendantSelected, setAttendantSelected] = useState({ FirstName: "", LastName: "" });
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const posGroupId = defaultSite.IntegratedSystem.POSGroupId;

    const closeErrorSnackbar = () => {
        setOpenError(false);
    };

    const onObservationValueChange = (event, item) => {
        var obj = JSON.parse(JSON.stringify(observationTemplateOption));

        obj.forEach((i) => {
            if (i.Id === item.Id) {
                i.Checked = event.target.checked;
            }
        });
        setObservationTemplateOption(obj);
    }

    const onInterventionValueChange = (event, item) => {
        var obj = JSON.parse(JSON.stringify(interventionTemplateOption));

        obj.forEach((i) => {
            if (i.Id === item.Id) {
                i.Checked = event.target.checked;
            }
        });
        setInterventionTemplateOption(obj);
    }

    const onSafetyCheckValueChange = (event, item) => {
        var obj = JSON.parse(JSON.stringify(safetyCheckTemplateOption));

        obj.forEach((i) => {
            if (i.Id === item.Id) {
                i.Checked = event.target.checked;
            }
        });
        setSafetyCheckTemplateOption(obj);
    }

    const onLocationValueChange = (event, item) => {
        var obj = JSON.parse(JSON.stringify(locationCodeTemplateOption));

        obj.forEach((i) => {
            if (i.Id === item.Id) {
                i.Checked = event.target.checked;
            }
        });
        setLocationCodeTemplateOption(obj);
    }

    const onAttendantSelected = (event, values, id) => {
        if (values?.AppUserName) {
            var name = (values.FirstName == null ? '' : values.FirstName) + " " + (values.LastName == null ? '' : values.LastName);
            setObservationLogDto({ ...observationLogDto, Observer: name, ObserverUsername: values.AppUserName });
            setAttendantSelected(values);
        }

    };

    const saveObservationLog = () => {
  
        var dto = observationLogDto;
        var required = false;

        if (!dto.ObserverUsername) {
            setErrorMessage("Please enter a valid Observer.");
            setOpenError(true);
            return false;
        }


        dto.ObservationIds = "";
        dto.InterventionIds = "";
        dto.SafetyCheckIds = "";
        dto.LocationIds = "";

        observationTemplateOption.forEach((item) => {

            if (item.Checked) {
                if (item.Description === "Other") {
                    if (!dto.Comments) {
                        setErrorMessage("Please enter an Comments.");
                        setOpenError(true);
                        required = true;
                        return false;
                    }
                }

                dto.ObservationIds += item.CodeID + ",";
            }
        });

        interventionTemplateOption.forEach((item)=> {

            if (item.Checked) {
                dto.InterventionIds += item.CodeID + ",";
            }
        });

        safetyCheckTemplateOption.forEach((item) => {

            if (item.Checked) {
                dto.SafetyCheckIds += item.CodeID + ",";
            }
        });

        locationCodeTemplateOption.forEach((item) => {
            if (item.Checked) {
                dto.LocationIds += item.CodeID + ",";
            }
        });

        if (required) {
            return;
        }

        var templates = {
            observationOptions: observationTemplateOption,
            interventionOptions: interventionTemplateOption,
            safetyCheckOptions: safetyCheckTemplateOption,
            locationCodeOptions: locationCodeTemplateOption
        };

        dto.ObservationInterventionJson = JSON.stringify(templates);
        dto.Id = observationLogSelected.Id;
        submitObservationLog(dto);
    };

    const submitObservationLog = (dto) => {
        HttpService.post('/PatientSitting/SaveObservationLog',
            dto
        )
            .then((result) => {
                getObservationLog();
                close();
            },
                (error) => {
                      //This is intentional
                });
    };

    useImperativeHandle(ref, () => {
        return {
            save: saveObservationLog
        };
    });

    useEffect(() => {
        if (observationLogSelected.Observer) {
          
            var name = observationLogSelected.Observer.split(' ');
            setAttendantSelected({ FirstName: name[0], LastName: name[1] });
            setObservationLogDto({ ...observationLogDto, Observer: observationLogSelected.Observer, ObserverUsername: observationLogSelected.ObserverUsername });
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
                <Alert onClose={closeErrorSnackbar} severity="error">
                    {errorMessage}
                </Alert>
            </Snackbar>
            <Grid container
                direction="row"
                spacing={1}
            >
                <Grid item xs={12} sm={12}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker fullWidth disableToolbar autoOk
                            variant="inline"
                            inputVariant="outlined"
                            id="Time"
                            label="Time"
                            format="MM/dd/yyyy"
                            size="small"
                            disableFuture="true"
                            disabled={true}
                            InputAdornmentProps={{ position: "start" }}
                            PopoverProps={{
                                anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                transformOrigin: { horizontal: "left", vertical: "top" }
                            }}
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <Autocomplete
                        size="small"
                        id="Attendant"
                        options={attendants || []}
                        className={classes.mb5}
                        getOptionLabel=
                        {
                            (option) => `${option?.FirstName == null ? '' : option.FirstName} ${option?.LastName == null ? '' : option.LastName}`
                        }
                        value={attendantSelected}
                        filterSelectedOptions
                        getOptionSelected={(option, value) => option.FirstName === value.FirstName}
                        onChange={(e, v) => onAttendantSelected(e, v, 13)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                label="Observer"
                                placeholder="Attendant"
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <div style={{ color: '#4183c4' }}>
                        Prevent Harm: The overall goal of a Patient Observation Attendant is to prevent patients from harming themselves. If patient is pulling at IV lines/tubes/equipment, calmly ask patient to stop by gently holding their arm to stop possible injury. If immediate help is needed, push nurse call button and yell for help.
                    </div>
                </Grid>
                {(posGroupId === 1) &&
                    <Grid item xs={12} sm={4}>
                        <Grid container>
                            <Grid item xs={12}>
                                <Typography variant="h5" gutterBottom align="center">
                                    Safety Check
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <FormGroup style={{ display: "flex" }}>
                                    {
                                        safetyCheckTemplateOption.map((item) => {
                                            return (
                                                <>
                                                    <FormControlLabel
                                                        key={item.Id}
                                                        control={
                                                            <Checkbox
                                                                checked={item.Checked}
                                                                onChange={(e) => { onSafetyCheckValueChange(e, item); }}
                                                                value="Checked"
                                                            />
                                                        }
                                                        label={item.Description}
                                                        style={{ color: '#4183c4', wordWrap: 'break-word', wordBreak: 'normal' }}
                                                    />

                                                    {(item.SubOptionItem.length > 0) &&
                                                        <List className={classes.subItemList}>
                                                            {
                                                                item.SubOptionItem.map((subItem) => {
                                                                    return (
                                                                        <ListItem >
                                                                            <ListItemIcon className={classes.listItemIcon} >
                                                                                <LensIcon className={classNames(classes.lensIcon)} />
                                                                            </ListItemIcon>
                                                                            <ListItemText className={classes.subtext}
                                                                                primary={subItem.Description}
                                                                            />
                                                                        </ListItem>
                                                                    )
                                                                })
                                                            }
                                                        </List>
                                                    }

                                                </>
                                            )
                                        })
                                    }
                                </FormGroup>
                            </Grid>
                        </Grid>
                    </Grid>
                }
                <Grid item xs={12} sm={(posGroupId === 1) ? 4 : 8}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography variant="h5" gutterBottom align="center">
                                Observation
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <FormGroup style={{ display: "flex" }}>
                                {
                                    observationTemplateOption.map((item) => {
                                        return (
                                            <FormControlLabel
                                                key={item.Id}
                                                control={
                                                    <Checkbox
                                                        checked={item.Checked}
                                                        onChange={(e) => { onObservationValueChange(e, item); }}
                                                        value="Checked"
                                                    />
                                                }
                                                label={item.Description}
                                                style={{ color: '#4183c4', wordWrap: 'break-word', wordBreak: 'normal' }}
                                            />
                                        )
                                    })
                                }

                            </FormGroup>
                        </Grid>
                    </Grid>
                </Grid>
                {(posGroupId === 1) &&
                    <Grid item xs={12} sm={4}>
                        <Grid container>
                            <Grid item xs={12}>
                                <Typography variant="h5" gutterBottom align="center">
                                    Intervention
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <FormGroup style={{ display: "flex" }}>
                                    {
                                        interventionTemplateOption.map((item) => {
                                            return (
                                                <FormControlLabel
                                                    key={item.Id}
                                                    control={
                                                        <Checkbox
                                                            checked={item.Checked}
                                                            onChange={(e) => { onInterventionValueChange(e, item); }}
                                                            value="Checked"
                                                        />
                                                    }
                                                    label={item.Description}
                                                    style={{ color: '#4183c4', wordBreak: 'break-all' }}
                                                />
                                            )
                                        })
                                    }
                                </FormGroup>
                            </Grid>
                        </Grid>
                    </Grid>
                }
                {(posGroupId === 2) &&
                    <Grid item xs={12} sm={4}>
                        <Grid container>
                            <Grid item xs={12}>
                                <Typography variant="h5" gutterBottom align="center">
                                    Location
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <FormGroup style={{ display: "flex" }}>
                                    {
                                        locationCodeTemplateOption.map((item) => {
                                            return (
                                                <FormControlLabel
                                                    key={item.Id}
                                                    control={
                                                        <Checkbox
                                                            checked={item.Checked}
                                                            onChange={(e) => { onLocationValueChange(e, item); }}
                                                            value="Checked"
                                                        />
                                                    }
                                                    label={item.Description}
                                                    style={{ color: '#4183c4', wordWrap: 'break-word', wordBreak: 'normal' }}
                                                />
                                            )
                                        })
                                    }

                                </FormGroup>
                            </Grid>
                        </Grid>
                    </Grid>
                }
                <Grid item xs={12} sm={12}>
                    <TextField size="small" fullWidth
                        multiline
                        rows="4"
                        label="Comments"
                        variant="outlined"
                        value={observationLogDto.Comments || ""}
                        onChange={(e) => { setObservationLogDto({ ...observationLogDto, Comments: e.target.value }); }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
            </Grid>
        </div>
    );
});
export default ObservationLogAdd;